// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1_dyZ","label":"CategoryService_label__3KbzV","location":"CategoryService_location__PMVLA"};